import countryService from '../services/country';

export default {
  data: () => ({
    countryList: [],
  }),
  computed: {
    countriesOption() {
      if (this.countryList) {
        let country = [{ text: 'Worldwide', value: null }];
        window._.map(this.countryList, (val) => {
          const text = val.name;
          country.push({
            text,
            value: val.iso_code,
          });
        });
        return country;
      } else return [];
    },
  },
  methods: {
    getCountryList() {
      return countryService.all();
    },
  },
  created() {
    this.getCountryList().then((data) => {
      this.countryList = data;
    });
  },
};
